var map = {
	"./discord.png": 179,
	"./discord_default_pfp.png": 814,
	"./discord_logo.png": 413,
	"./discord_logo_large.png": 349,
	"./fish_list.png": 670,
	"./fish_list_all.png": 722,
	"./fishadd.png": 544,
	"./fishcord-logo-nbg.png": 453,
	"./fishcord-logo.png": 517,
	"./leaderboards.png": 759,
	"./lost_lure_leaderboards.png": 645,
	"./profile.png": 196
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;